module.exports = __webpack_public_path__ + "static/media/Aerobics.ea821e53.png";